module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_2_m-e93ba6f77792135e616d534a67f25d3b.webp";